import { Deserializable } from '../../protocols/deserializable';
import { PaymentMethodTypeEnum } from '../../enum/shared/payment-method-type-enum';
import { PaymentMethodType } from '../../types/dto/payment-method-type';

export class MemberPaymentMethod implements Deserializable {
  public paymentMethodTypeId!: PaymentMethodTypeEnum;
  public paymentMethodType!: PaymentMethodType;
  // Null on the rows that represent a payment method type the user can pick fresh (cash, cheque,
  // EFT, a new credit card); populated on instruments already saved to the member's record.
  public paymentMethodId!: number | null;
  public paymentMethod!: string | null;

  onDeserialize(): void {
    if (!!this.paymentMethodType) {
      this.paymentMethodType = window?.injector?.Deserialize?.instanceOf(PaymentMethodType, this.paymentMethodType);
    }
  }
}
